module.exports = "//static.hsappstatic.net/marketplace-storefront-base/static-1.11468/assets/images/app-marketplace.jpg"